import $ from 'jquery';


const pager = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: '',
        url: null,
        targetSelector: null,
        startIndex: 1,
        endIndex: null
    }, options);


    m = pager.markup;


    internal = {
        $e: o.$e || $(o.selector),
        url: o.url,
        targetSelector: o.targetSelector,
        startIndex: o.startIndex,
        endIndex: o.endIndex,
        currentIndex: o.startIndex
    };


    elements = {
        target: $(internal.targetSelector)
    };


    fn = {
        init () {
            if (internal.startIndex > internal.endIndex) {
                internal.$e.fadeOut('fast');
                return;
            }

            if (elements.target.length > 0) {
                internal.$e.on('click', handlers.pagerClick);
            }
        },

        loadPage () {
            $.ajax({
                url: `${internal.url}${internal.currentIndex}`,
                beforeSend: () => {
                    internal.$e.addClass(m.LOADING);
                },
                error (data) {
                    console.info(`Error loading page ${internal.currentIndex}: ${data.status} ${data.statusText}`);
                },
                success: fn.addPage,
                complete () {
                    internal.$e.removeClass(m.LOADING);
                }
            });
        },

        addPage (html) {
            const $html = $(html);

            $html.css('display', 'none').appendTo(elements.target).fadeIn();

            internal.currentIndex++;

            if (internal.currentIndex > internal.endIndex) {
                internal.$e.fadeOut('slow');
            }
        }
    };


    handlers = {
        pagerClick: function (e) {
            if (internal.currentIndex <= internal.endIndex) {
                fn.loadPage();
            }
            e.preventDefault();
        }
    };


    fn.init();
};


pager.markup = {
    // dom selector
    CONTAINER: 'pager',

    // states
    LOADING: 'state-loading'
};


export default pager;



// WEBPACK FOOTER //
// ./assets/js/components/pager.js